__turbopack_context__.v({
  "root": "b-px3q_root",
  "u-shimmer": "b-px3q_u-shimmer",
});
